var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-link',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-sm",attrs:{"to":'/shareholder/update/' + _vm.row.id}},[_c('i',{staticClass:"fas fa-edit"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }